'use client'

import React, { useEffect } from 'react'

interface Review {
  rating: number
  name: string
  comment: string
  avatar?: string
}

export default function ReviewsList({
  open,
  onClose,
  reviews = [],
  translations
}: {
  open: boolean
  onClose: () => void
  reviews?: Review[]
  translations:any
}) {
  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return (
    <div
      className={`fixed inset-0 z-[60] flex items-center justify-center transition-opacity duration-500 ${
        open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
      }`}
      aria-hidden={!open}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
      style={{ backgroundColor: 'rgba(0,0,0,0.35)', backdropFilter: open ? 'blur(4px)' : 'none' }}
    >
      <div
        className={`bg-white w-full max-w-lg mx-4 md:mx-0 rounded-xl shadow-lg transform transition-transform duration-500 ${
          open ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
        }`}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">{translations["cust_reviews"]||"Customer reviews"}</h3>
          <button
            onClick={onClose}
            aria-label="Close reviews"
            className="p-2 rounded hover:bg-gray-100"
          >
            ✕
          </button>
        </div>

        <div className="p-4 max-h-[70vh] overflow-y-auto space-y-3">
          {reviews.length === 0 ? (
            <div className="text-center text-gray-500 py-12">{translations["empty_review"]||"No reviews available."}</div>
          ) : (
            reviews.map((r, i) => (
              <div key={i} className="border rounded-lg p-3 bg-white">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden">
                      {r.avatar ? <img src={r.avatar} alt={r.name} className="w-full h-full object-cover" /> : <svg className="w-6 h-6 text-gray-400" viewBox="0 0 24 24" fill="none"><path d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zM4 20c0-2.667 4-4 8-4s8 1.333 8 4v1H4v-1z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                    </div>
                    <div>
                      <div className="font-semibold text-sm">{r.name}</div>
                      <div className="text-xs text-gray-500">{r.rating} <span className="text-yellow-400">★</span></div>
                    </div>
                  </div>
                </div>
                <p className="mt-3 text-sm text-gray-700">{r.comment}</p>
              </div>
            ))
          )}
        </div>

        {/* <div className="p-4 border-t text-right">
          <button onClick={onClose} className="px-4 py-2 rounded bg-[#6D401A] text-white">Close</button>
        </div> */}
      </div>
    </div>
  )
}